/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useContext, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '@xometry/auth-context';
import { Spinner } from '@xometry/xometry_loft';
import { useQuery } from '@apollo/client';
import {
  WWW_ORIGIN,
  API_ORIGIN,
  STATSIG_CLIENT_KEY,
  STATSIG_ENV,
} from '../../config';
import history from '../../history';
import { PartnerByUserIdQuery } from '../../schema/generated/schema';
import { lazyWithRetries } from '../../utils/shimport';

const AccountPageLink = `${WWW_ORIGIN}/components/partner-account-component/component.mjs`;
const AccountPage = lazyWithRetries(AccountPageLink);

const SupplierAccount = () => {
  const { isLoading, user } = useContext(AuthContext);
  const { userId = '' } = useParams();
  const { loading: isLoadingPartnerId, data: partnerData } = useQuery(
    PartnerByUserIdQuery,
    { variables: { userId } }
  );

  if (isLoading || isLoadingPartnerId) return <Spinner />;
  if (!user) {
    window.location.assign('/login');
  }

  const config = {
    user: {
      id: userId || user.id,
      isStaff: !!userId,
      partner: {
        id: partnerData?.partnerByUserId?.partner?.id,
      },
    },
    origins: {
      xometry: {
        api: API_ORIGIN,
        www: WWW_ORIGIN,
      },
    },
    statsig: {
      clientKey: STATSIG_CLIENT_KEY,
      env: STATSIG_ENV,
    },
    subpath: '/account/supplier',
  };

  return (
    <Suspense fallback={<Spinner />}>
      <AccountPage history={history} config={config} />
    </Suspense>
  );
};

export default SupplierAccount;
